import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/layout'
import Login from '@/components/Login'

import Charts from '@/views/charts'

import Dashboard from '@/views/dashboard'

import CourseStudy from '@/views/course/study'
import CourseUnit from '@/views/course/unit'
import CourseGrade from '@/views/course/grade'

import ChangePassword from '@/views/user/changePwd'
import UserCenter from '@/views/user/userCenter'
import StudyRecord from '@/views/user/studyRecord'
import Ranking from '@/views/user/ranking'
import Notice from '@/views/user/notice'

import BuyTip from '@/views/help/buyTip'

import UserList from '@/views/manager/userList'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      hidden: true
    },
    {
      path: '/charts',
      name: 'charts',
      component: Charts,
      hidden: true
    },
    {
      path: '/',
      redirect: '/user/center',
      name: 'index',
      component: Layout,
      children: [{
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard
      }]
    },
    {
      path: '/course',
      redirect: '/course/study',
      name: 'course',
      component: Layout,
      children: [{
        path: 'study/:id',
        name: 'courseStudy',
        component: CourseStudy
      }, {
        path: 'unit/:id',
        name: 'courseUnit',
        component: CourseUnit
      }, {
        path: 'grade/:id',
        name: 'courseGrade',
        component: CourseGrade
      }]
    },
    {
      path: '/user',
      redirect: '/user/center',
      name: 'user',
      component: Layout,
      hidden: true,
      children: [{
        path: 'center',
        name: 'center',
        component: UserCenter
      }, {
        path: 'studyrecord',
        name: 'studyRecord',
        component: StudyRecord
      }, {
        path: 'ranking',
        name: 'ranking',
        component: Ranking
      }, {
        path: 'changepassword',
        name: 'changePassword',
        component: ChangePassword
      }, {
        path: 'notice',
        name: 'notice',
        component: Notice
      }]
    },
    {
      path: '/help',
      redirect: '/help/buytip',
      name: 'help',
      component: Layout,
      children: [{
        path: 'buytip',
        name: 'buyTip',
        component: BuyTip
      }]
    },
    {
      path: '/manager',
      redirect: '/manager/userlist',
      name: 'manager',
      component: Layout,
      children: [{
        path: 'userlist',
        name: 'userList',
        component: UserList,
        meta: { admin: true }
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js